import { isDark } from './is-dark.js';
/**
 * @internal
 */
export function directionByIsDark(color) {
    return isDark(color) ? -1 : 1;
}
